export interface EstadosCuentasCorrientesClientes {
  IDCLIENTE: number;
  CLIENTE: string;
  ACTIVO: 'SI' | 'NO';
  DOMICILIO: string;
  TELEFONO: string;
  CELULAR: string;
  'ULTIMA COMPRA': string;
  'ULTIMO PAGO': string;
  FACTURADO: string;
  CREDITO: string;
  PAGADO: string;
  SALDO: string;
  VENDEDOR: string;
}

  export const reporteEstadosDeCuentasClientesGridColumnDefinitions = {
    'CLIENTE': { Header: 'Cliente' },
    'FACTURADO': { Header: 'Facturado $', IsNumber: true },
    'CREDITO': { Header: 'Credito $', IsNumber: true },
    'PAGADO': { Header: 'Pagado $', IsNumber: true },
    'SALDO': { Header: 'Saldo $', IsNumber: true },
};